import styled from 'styled-components'

export const Property = styled.span`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.GREY_550};
  white-space: nowrap;
`

export const Details = styled.div`
  display: flex;
  align-items: center;

  > * {
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    position: relative;

    &:after {
      content: '';
      width: 2px;
      height: 2px;
      background-color: ${({ theme }) => theme.colors.GREY_250};
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%) translateX(50%);
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`
